import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'linkify',
})
export class LinkifyPipe implements PipeTransform {
  urlPattern = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;

  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(
    input: string,
    linkify: boolean = true,
    removeClass: string | null = null
  ): SafeHtml {
    if (!input) return '';

    // Parse as HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString('<div>' + input + '</div>', 'text/html');

    // Linkify any bare URLs outside anchors
    if (linkify) {
      this.linkifyElements(doc.body);
    }

    // Remove <a> tags with ".removing-class" ONLY
    if (removeClass) {
      doc.querySelectorAll(`a.${removeClass}`).forEach((a) => {
        const text = a.textContent || '';
        a.replaceWith(text);
      });
    }

    return /**NOSONAR*/ this.sanitizer.bypassSecurityTrustHtml(
      doc.body.innerHTML
    );
  }

  /** Recursively linkifies only text nodes outside anchor tags */
  private linkifyElements(element: HTMLElement | ChildNode) {
    Array.from(element.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        if (text && this.urlPattern.test(text)) {
          const span = document.createElement('span');
          span.innerHTML = text.replace(this.urlPattern, (url: string) => {
            const href = url.startsWith('http') ? url : `http://${url}`;
            return `<a href="${href}" class="removing-class" target="_blank" rel="noopener noreferrer">${url}</a>`;
          });
          node.parentNode!.replaceChild(span, node);
        }
      } else if (
        node.nodeType === Node.ELEMENT_NODE &&
        (node as Element).tagName.toLowerCase() !== 'a'
      ) {
        this.linkifyElements(node as HTMLElement);
      }
    });
  }
}
